module.exports = __webpack_public_path__ + "img/refresh.15a76578.svg";